export const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;
